import { MeasurementType as MeasurementTypeAll } from '@/@types/global';
import { Injectable } from '@angular/core';

// HeartRate need to be deleted
type MeasurementType = Exclude<MeasurementTypeAll, 'StepCount' | 'Sleep' | 'Exercise' | 'Cuisine' | 'HeartRate'>;

const ADVISE: Record<MeasurementType, SeverityResult[]> = {
    BloodPressure: [
        {
            typeText: '血壓',
            level: 0,
            message: [{
                title: '血壓正常，請繼續維持良好習慣！',
                content:
                    '目前血壓穩定，建議持續規律運動、健康飲食，每年至少量一次血壓，提早掌握身體變化。',
            }],
        },
        {
            typeText: '血壓',
            level: 1,
            message: [{
                title: '血壓偏高，建議立即調整生活型態。',
                content:
                    '此為高血壓前期，建議減少油鹽、糖攝取，戒菸限酒，增加運動量與規律運動，並持續監測血壓變化。',
            }],
        },
        {
            typeText: '血壓',
            level: 2,
            message: [{
                title: '血壓偏高，請盡速就醫確認！',
                content:
                    '您的血壓已達到高血壓範圍，建議就醫確認，依醫師建議持續監測與治療，並配合飲食及生活型態調整。',
            }],
        },
    ],
    BloodSugar: [
        {
            typeText: '血糖',
            level: 0,
            message: [{
                title: '血糖正常，請持續保持良好生活習慣。',
                content: '持續維持健康飲食與規律運動，避免肥胖及不良生活習慣，並定期檢查血糖，預防未來風險。',
            }],
        },
        {
            typeText: '血糖',
            level: 1,
            message: [{
                title: '血糖略高，建議立即調整生活型態。',
                content: '建議調整飲食結構，減少精緻糖與高熱量攝取，增加每日體力活動，每週150分鐘以上運動，並定期追蹤血糖，預防進展為糖尿病。',
            }],
        },
        {
            typeText: '血糖',
            level: 2,
            message: [{
                title: '血糖過高，請儘速就醫並配合專業治療。',
                content: '請儘速就醫，由醫師及營養師協助制定個人化治療計劃，配合規律用藥與日常血糖監測，並加強健康生活習慣控制。',
            }],
        },
    ],
    BloodOxygen: [
        {
            typeText: '血氧',
            level: 0,
            message: [{
                title: '血氧正常',
                content: '您的血氧數值在正常範圍內，建議持續保持良好生活習慣。',
            }],
        },
        {
            typeText: '血氧',
            level: 1,
            message: [{
                title: '血氧偏低',
                content: '需盡快深呼吸增加氧氣攝取，避免劇烈運動與勞累。長期異常需盡快就醫。',
            }],
        },
        {
            typeText: '血氧',
            level: 2,
            message: [{
                title: '血氧過低',
                content:
                    '需要緊急就醫評估並接受氧氣治療，避免組織和器官損害。長期異常需在醫師指示下進行復原訓練。',
            }],
        },
    ],
    BMI: [
        {
            typeText: 'BMI指數',
            level: 0,
            message: [{
                title: '健康體位',
                content: '定期監測體重與身體組成，維持理想體態。',
            }],
        },
        {
            typeText: 'BMI指數',
            level: 1,
            message: [{
                title: '體重過輕',
                content: '建議加強營養補充，若體重明顯偏低，應尋求醫療與營養諮詢。',
            }, {
                title: '體重過重',
                content: '建議控制飲食及增加運動。',
            }],
        },
        {
            typeText: 'BMI指數',
            level: 2,
            message: [{
                title: '肥胖',
                content: '請積極改變生活型態，必要尋求專業協助。',
            }],
        },
    ],
    Waist: [
        {
            typeText: '腰圍',
            level: 0,
            message: [{
                title: '腰圍正常',
                content: '請持續維持健康生活習慣。',
            }],
        },
        {
            typeText: '腰圍',
            level: 1,
            message: [{
                title: '腰圍偏高',
                content: '建議加強飲食控制與規律運動，降低慢性病風險。',
            }],
        },
        {
            typeText: '腰圍',
            level: 2,
            message: [{
                title: '腰圍明顯超標',
                content: '請特別留意血糖、血壓等代謝指標，必要時可諮詢專業醫師。',
            }],
        },
    ],
    BodyFatPercentage: [
        {
            typeText: '體脂肪',
            level: 0,
            message: [{
                title: '體脂肪正常',
                content: '保持運動與健康飲食習慣，持續維持良好生活習慣。',
            }],
        },
        {
            typeText: '體脂肪',
            level: 1,
            message: [{
                title: '體脂肪偏低',
                content: '體脂肪不足會降低免疫力與耐力，請注意均衡飲食與適量運動。',
            }, {
                title: '體脂肪略高',
                content:
                    '建議減少高油高糖食物攝取，規律運動與控制飲食，預防相關慢性疾病風險上升。',
            }],
        },
        {
            typeText: '體脂肪',
            level: 2,
            message: [{
                title: '體脂肪過高',
                content:
                    '建議積極控制飲食與規律運動，降低代謝症候群與慢性疾病風險。',
            }],
        },
    ],
    BodyTemperature: [
        {
            typeText: '體溫',
            level: 0,
            message: [{
                title: '正常體溫',
                content: '代表身體代謝與免疫系統正常。',
            }],
        },
        {
            typeText: '體溫',
            level: 1,
            message: [{
                title: '低燒',
                content:
                    '可能是身體免疫反應或輕微感染的表現，建議補充睡眠、避免劇烈運動，如有持續不適，應就醫檢查。',
            }],
        },
        {
            typeText: '體溫',
            level: 2,
            message: [{
                title: '高燒',
                content:
                    '可能是感染發炎或其他免疫系統異常，建議立即就醫以避免潛在併發症。',
            }],
        },
    ],
    TotalCholesterol: [
        {
            typeText: '血脂',
            level: 0,
            message: [{
                title: '血脂正常',
                content: '請持續保持均衡飲食與運動習慣，維持健康狀態。',
            }],
        },
        {
            typeText: '血脂',
            level: 1,
            message: [{
                title: '血脂偏高',
                content: '建議調整生活型態，減少高油高糖飲食、增加蔬果攝取與規律運動，並持續追蹤血脂變化。',
            }],
        },
        {
            typeText: '血脂',
            level: 2,
            message: [{
                title: '血脂過高',
                content: '建議立即調整飲食與生活型態，必要時就醫進一步檢查與治療。',
            }],
        },
    ],
    UricAcid: [
        {
            typeText: '尿酸',
            level: 0,
            message: [{
                title: '尿酸正常',
                content: '持續維持健康飲食與生活作息，保持身體代謝平衡。',
            }],
        },
        {
            typeText: '尿酸',
            level: 1,
            message: [{
                title: '尿酸偏低',
                content:
                    '建議注意營養攝取，若持續偏低，請諮詢醫師評估可能的健康狀況。',
            }],
        },
        {
            typeText: '尿酸',
            level: 2,
            message: [{
                title: '高尿酸血症',
                content:
                    '建議減少高普林食物與酒精攝取，並諮詢醫師確認進一步檢查與治療。',
            }],
        },
    ],
};

 type Sex = 0 | 1; // 0 = female, 1 = male

interface MeasurementItem {
    code?: string;
    name?: string;
    value?: number;
    time?: string;
    notes?: string;
}

export interface MeasurementRequest {
    date: string;
    userId?: number;
    source?: string;
    items: MeasurementItem[];
}

export interface SeverityResult {
    typeText: string;
    level: 0 | 1 | 2; // 0=normal/info, 1=warning, 2=danger
    message: {
        title: string;
        content: string;
    }[];
}

interface EvalResult {
    level: 0 | 1 | 2;
    msgIndex: number;
}

@Injectable({ providedIn: 'root' })
export class SeverityAdviceService {
    private _sex: Sex = 1; // default male (matches severity-tag.service)

    setSex(s: Sex) {
        this._sex = s === 1 ? 1 : 0;
    }

    get sex() { return this._sex; }

    private num(v: number | string | undefined | null): number | null {
        if (v === undefined || v === null) return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    }

    evaluate(type: MeasurementTypeAll, req: MeasurementRequest): SeverityResult {
        switch (type) {
        case 'BloodPressure': {
            const level = this.evalBloodPressure(req);
            return ADVISE.BloodPressure[level];
        }
        case 'BloodSugar': {
            const level = this.evalBloodSugar(req);
            return ADVISE.BloodSugar[level];
        }
        case 'BloodOxygen': {
            const level = this.evalBloodOxygen(req);
            return ADVISE.BloodOxygen[level];
        }
        case 'BMI': {
            const res = this.evalBMI(req);
            const message = ADVISE.BMI[res.level].message[res.msgIndex];
            return { ...ADVISE.BMI[res.level], message: [message] };
        }
        case 'Waist': {
            const level = this.evalWaist(req);
            return ADVISE.Waist[level];
        }
        case 'BodyTemperature': {
            const level = this.evalBodyTemp(req);
            return ADVISE.BodyTemperature[level];
        }
        case 'BodyFatPercentage': {
            const res = this.evalBodyFatPercentage(req);
            const message = ADVISE.BodyFatPercentage[res.level].message[res.msgIndex];
            return { ...ADVISE.BodyFatPercentage[res.level], message: [message] };
        }
        case 'TotalCholesterol': {
            const level = this.evalTotalCholesterol(req);
            return ADVISE.TotalCholesterol[level];
        }
        case 'UricAcid': {
            const level = this.evalUricAcid(req);
            return ADVISE.UricAcid[level];
        }
        default:
            return {
                typeText: '',
                level: 0,
                message: [{
                    title: '',
                    content: '',
                }],
            };
        }
    }

    private evalBloodPressure(req: MeasurementRequest): 0 | 1 | 2 {
        const items = req.items;
        const sb = items.find((i) => i.code === 'SBP' || (i.name ?? '').includes('收縮'));
        const db = items.find((i) => i.code === 'DBP' || (i.name ?? '').includes('舒張'));
        const systolic = this.num(sb?.value);
        const diastolic = this.num(db?.value);
        if (systolic == null || diastolic == null) return 0;

        if (systolic > 180 || diastolic > 120) return 2; // danger
        if (systolic >= 140 || diastolic >= 90) return 1; // warn
        if ((systolic >= 130 && systolic <= 139) || (diastolic >= 80 && diastolic <= 89)) return 1; // warn
        if (systolic >= 120 && systolic <= 129 && diastolic < 80) return 0; // info -> treated as normal
        if (systolic < 120 && diastolic < 80) return 0; // success
        return 0;
    }

    private evalBloodSugar(req: MeasurementRequest): 0 | 1 | 2 {
        const items = req.items;
        const fasting = items.find((i) => i.code === 'AC' || (i.name ?? '').includes('空腹'));
        const post = items.find((i) => i.code === 'PC' || (i.name ?? '').includes('飯後'));
        const f = this.num(fasting?.value);
        const p = this.num(post?.value);

        if (f != null) {
            if (f >= 126) return 2;
            if (f >= 100 && f <= 125) return 1;
            if (f >= 70 && f <= 99) return 0;
            return 0;
        }
        else if (p != null) {
            if (p >= 200) return 2;
            if (p >= 140 && p <= 199) return 1;
            if (p < 140) return 0;
            return 0;
        }
        return 0;
    }

    private evalBloodOxygen(req: MeasurementRequest): 0 | 1 | 2 {
        const items = req.items;
        const it = items.find((i) => i.code === 'BO' || (i.name ?? '').includes('血氧'));
        const v = this.num(it?.value);
        if (v == null) return 0;
        if (v < 90) return 2;
        if (v >= 90 && v <= 94) return 1;
        if (v >= 95 && v <= 100) return 0;
        return 0;
    }

    private evalBMI(req: MeasurementRequest): EvalResult {
        const items = req.items;
        const it = items.find((i) => i.code === 'BMI' || (i.name ?? '').includes('BMI') || (i.name ?? '').includes('身體質量'));
        const v = this.num(it?.value);
        if (v == null) return { level: 0, msgIndex: 0 };
        if (v > 27) return { level: 2, msgIndex: 0 };
        if (v >= 24 && v <= 27) return { level: 1, msgIndex: 1 };
        if (v < 18.5) return { level: 1, msgIndex: 0 };
        if (v >= 18.5 && v < 24) return { level: 0, msgIndex: 0 };
        return { level: 0, msgIndex: 0 };
    }

    private evalWaist(req: MeasurementRequest): 0 | 1 | 2 {
        const items = req.items;
        const it = items.find((i) => i.code === 'WC' || (i.name ?? '').includes('腰圍'));
        const v = this.num(it?.value);
        if (v == null) return 0;

        if (this._sex === 1) { // male
            if (v > 100) return 2;
            if (v >= 90 && v <= 99.9) return 1;
            if (v < 90) return 0;
        }
        else { // female
            if (v > 88) return 2;
            if (v >= 80 && v <= 87.9) return 1;
            if (v < 80) return 0;
        }
        return 0;
    }

    private evalBodyTemp(req: MeasurementRequest): 0 | 1 | 2 {
        const items = req.items;
        const it = items.find((i) => i.code === 'TMP' || (i.name ?? '').includes('體溫'));
        const v = this.num(it?.value);
        if (v == null) return 0;
        if (v > 40) return 2;
        if (v >= 38 && v <= 40) return 1;
        if (v < 35) return 1;
        if (v >= 35 && v < 38) return 0;
        return 0;
    }

    private evalBodyFatPercentage(req: MeasurementRequest): EvalResult {
        const items = req.items;
        const it = items.find((i) => i.code === 'BFP' || (i.name ?? '').includes('體脂肪'));
        const v = this.num(it?.value);
        if (this._sex === 1) {
            if (v == null) return { level: 0, msgIndex: 0 };
            if (v < 11) return { level: 1, msgIndex: 0 };
            if (v >= 11 && v <= 21) return { level: 0, msgIndex: 0 };
            if (v > 25) return { level: 2, msgIndex: 0 };
            if (v > 21 && v <= 25) return { level: 1, msgIndex: 1 };
        }
        else {
            if (v == null) return { level: 0, msgIndex: 0 };
            if (v < 20) return { level: 1, msgIndex: 0 };
            if (v >= 21 && v <= 33) return { level: 0, msgIndex: 0 };
            if (v > 38) return { level: 2, msgIndex: 0 };
            if (v > 33 && v < 38) return { level: 1, msgIndex: 1 };
        }
        return { level: 0, msgIndex: 0 };
    }

    private evalTotalCholesterol(req: MeasurementRequest): 0 | 1 | 2 {
        const items = req.items;
        const it = items.find((i) => i.code === 'BFP' || (i.name ?? '').includes('體脂肪'));
        const v = this.num(it?.value);
        if (v == null) return 0;
        if (v >= 240) return 2;
        if (v >= 200 && v < 240) return 1;
        if (v < 200) return 0;
        return 0;
    }

    private evalUricAcid(req: MeasurementRequest): 0 | 1 | 2 {
        const items = req.items;
        const it = items.find((i) => i.code === 'UA' || (i.name ?? '').includes('尿酸'));
        const v = this.num(it?.value);
        if (v == null) return 0;

        if (this._sex === 1) { // male
            if (v < 3) return 2;
            if (v >= 3 && v <= 7) return 1;
            if (v > 7) return 0;
        }
        else { // female
            if (v < 2.5) return 2;
            if (v >= 2.5 && v <= 6) return 1;
            if (v > 6) return 0;
        }
        return 0;
    }
}
